import React from 'react'
import css from './IndexDisplay.css'
type IndexDisplayProps = {
  label: string
  value: number | string
}

const IndexDisplay = ({ label, value }: IndexDisplayProps) => (
  <div className={css.indexDisplay}>
    <div className={css.indexLabel}>{label}</div>
    <div className={css.indexValue}>{value}</div>
  </div>
)

export default IndexDisplay
